export namespace S25Cookie {
    //adapted from https://www.w3schools.com/js/js_cookies.asp
    export function set(
        cname: string,
        cvalue: string | number | boolean,
        exminutes?: number,
        secure?: boolean,
        path?: string,
    ): void {
        exminutes = exminutes || 60 * 24; //default to 1 day
        path = path || "/";
        const d = new Date();
        d.setTime(d.getTime() + exminutes * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=" + path + (secure ? ";secure" : "");
    }

    //adapted from https://www.w3schools.com/js/js_cookies.asp
    export function get(cname: string): string | null {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            // TODO: trim() c instead of skipping only the first space.
            c = c.substring(c.indexOf(" ") + 1); //skip spaces
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }

    export function remove(cname: string, path?: string) {
        set(cname, "", -10000, undefined, path);
    }
}
